import { ComponentProps } from 'react';

export function RestworldPurpleIcon(props: ComponentProps<'svg'>) {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill="#F0EBF8"
      />
      <g clipPath="url(#clip0_4029_4712)">
        <path
          d="M34.5932 14.9683C34.0174 14.3596 33.0402 14.3195 32.4133 14.8797C32.3102 14.9718 29.8638 17.1797 27.8065 20.5754C26.7252 22.3612 25.8887 24.1173 25.2981 25.5011C24.7199 24.7958 24.0943 24.0643 23.4287 23.3143C22.8372 22.6491 22.2007 21.9521 21.5096 21.2892C23.294 19.4421 24.5212 16.8365 24.6872 14.4717C24.8424 12.2674 24.3623 10.6196 23.2202 9.43772C21.9958 8.17084 20.199 7.68633 18.6424 8.20528C16.19 9.02154 14.2186 12.2367 13.8477 16.0229C13.8017 16.4888 13.7751 16.9984 13.7666 17.5444C10.4837 17.2048 7.20324 18.5399 6.26961 20.6039C5.68898 21.8861 6.05873 23.2566 7.25767 24.2686C8.6966 25.4834 11.1324 25.7736 14.1146 25.0848C14.2128 25.0613 14.3121 25.0377 14.4117 25.013C14.7451 27.1444 15.0857 28.7142 15.1269 28.9028C15.3038 29.7108 16.1246 30.2286 16.9575 30.0576C17.3611 29.9737 17.7066 29.7426 17.9312 29.4065C18.1556 29.0703 18.2307 28.6682 18.1444 28.2765C18.1275 28.1952 17.73 26.3526 17.382 24.0019C17.9783 23.7423 18.5411 23.4618 19.0624 23.1621C19.7751 23.8167 20.4565 24.5609 21.0942 25.2782C23.3298 27.794 24.4694 29.4171 24.4815 29.4336L26.2732 32L27.2298 29.0394C27.2407 29.0053 28.3707 25.5575 30.4656 22.1004C32.2633 19.1316 34.4153 17.1688 34.5027 17.0888C35.129 16.5286 35.1689 15.577 34.5932 14.9683ZM9.30165 22.1572C9.09565 21.952 9.07628 21.63 9.16339 21.4307C9.32947 21.0534 10.412 20.4917 12.7192 20.4917C12.9788 20.4917 13.2405 20.5071 13.4989 20.5353C13.6262 20.5494 13.7521 20.5659 13.877 20.5848C13.9146 21.0495 13.956 21.5379 14.0107 22.0356C11.5132 22.7129 9.77088 22.622 9.30165 22.1572ZM19.1178 19.375C18.3892 18.9102 17.641 18.5388 16.8508 18.2473C16.8411 17.5232 16.8641 16.8721 16.9198 16.3069C17.1975 13.4644 18.4292 11.4887 19.4475 11.0749C19.4572 11.0702 20.5569 10.6869 21.2685 11.424C22.0176 12.199 21.9244 13.2993 21.7608 14.1708C21.4697 15.7121 20.7851 17.2604 19.9004 18.4601C19.6538 18.7948 19.3916 19.1021 19.1178 19.375Z"
          fill="#4A2983"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.1641 28.9989L23.0293 27.5491L25.2976 25.4993C24.5893 26.6763 24.2366 27.802 24.1641 28.9989Z"
          fill="url(#paint0_linear_4029_4712)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.877 20.5813C13.8917 20.9266 13.9868 21.8042 14.0111 22.0262C15.272 22.3725 16.3769 23.0657 17.3818 24.0018C17.2966 23.3531 17.1463 21.9954 17.0987 21.4747C16.0493 20.9528 15.318 20.7258 13.877 20.5813Z"
          fill="url(#paint1_linear_4029_4712)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.1133 19.3771C19.5649 18.8904 19.9687 18.3804 20.3234 17.8464L22.7438 19.7597C22.3821 20.3152 21.9493 20.8259 21.5033 21.2904C20.729 20.5918 19.9574 19.9445 19.1133 19.3771Z"
          fill="url(#paint2_linear_4029_4712)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8938 15.6304C14.909 15.8011 15.9162 16.0102 16.9183 16.2434C16.849 16.907 16.8539 17.5883 16.874 18.2585C15.8468 17.9225 14.8095 17.6748 13.7578 17.552C13.7753 16.9231 13.7929 16.2822 13.8938 15.6304Z"
          fill="url(#paint3_linear_4029_4712)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2754 22.4087C12.8621 22.311 13.4431 22.1949 14.0098 22.0312C14.1286 23.0156 14.2647 24.0057 14.4066 24.9977C13.8799 25.1358 13.3469 25.2399 12.8082 25.3134C12.6847 24.3465 12.5164 23.3785 12.2754 22.4087Z"
          fill="url(#paint4_linear_4029_4712)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3811 24.0013C17.9658 23.7599 18.5188 23.4716 19.0625 23.1619C18.4041 22.5071 17.7977 21.9278 17.0986 21.4797C17.1743 22.3618 17.268 23.1235 17.3811 24.0013Z"
          fill="#2C184E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4029_4712"
          x1="24.1418"
          y1="27.0283"
          x2="25.0562"
          y2="27.7348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4A2983" />
          <stop offset={1} stopColor="#2C184E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4029_4712"
          x1="15.5989"
          y1="20.8984"
          x2="15.0079"
          y2="22.2887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C184E" />
          <stop offset={1} stopColor="#4A2983" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4029_4712"
          x1="20.2249"
          y1="20.19"
          x2="21.4852"
          y2="18.8476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C184E" />
          <stop offset={1} stopColor="#4A2983" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4029_4712"
          x1="15.1661"
          y1="17.7985"
          x2="15.362"
          y2="15.9387"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C184E" />
          <stop offset={1} stopColor="#4A2983" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4029_4712"
          x1="13.0307"
          y1="23.6283"
          x2="14.1277"
          y2="23.3335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4A2983" />
          <stop offset={1} stopColor="#2C184E" />
        </linearGradient>
        <clipPath id="clip0_4029_4712">
          <rect width={29} height={24} fill="white" transform="translate(6 8)" />
        </clipPath>
      </defs>
    </svg>
  );
}
